<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Farm Alerts</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="primary">
      <ion-label> Settings </ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-toggle [checked]="subscribeToFarmAlerts" (click)="toggle('subscribeToFarmAlerts', $event)">
        Subscribe to Farm Alerts
      </ion-toggle>
    </ion-item>
  </ion-list>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider>
      <ion-label> Notifications </ion-label>
    </ion-item-divider>
    <ion-item>
      <ion-toggle
        [checked]="farmAlertsEmailNotifications"
        [disabled]="!subscribeToFarmAlerts"
        (click)="toggle('farmAlertEmailNotifications', $event)"
      >
        Receive E-mail Notifications
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle
        [checked]="farmAlertsPushNotifications"
        [disabled]="!subscribeToFarmAlerts"
        (click)="toggle('farmAlertPushNotifications', $event)"
      >
        Receive Push Notifications
      </ion-toggle>
    </ion-item>
  </ion-list>
</red-page-content>
